import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SessionExtendData {
  timeRemaining: number; // in milliseconds
}

@Component({
  selector: 'app-session-extend-modal',
  templateUrl: './session-extend-modal.component.html',
  styleUrls: ['./session-extend-modal.component.scss']
})
export class SessionExtendModalComponent implements OnInit, OnDestroy {
  public dialogRef = inject(MatDialogRef<SessionExtendModalComponent>);
  public data = inject<SessionExtendData>(MAT_DIALOG_DATA);
  timeRemainingFormatted: string;
  private timeRemainingMs: number;
  private countdownInterval?: ReturnType<typeof setInterval>;

  constructor() {
    this.timeRemainingMs = this.data.timeRemaining;
    this.timeRemainingFormatted = this.formatTime(this.timeRemainingMs);
  }

  ngOnInit(): void {
    // Update countdown every second
    this.countdownInterval = setInterval(() => {
      this.timeRemainingMs -= 1000; // Decrease by 1 second

      if (this.timeRemainingMs <= 0) {
        this.timeRemainingMs = 0;
        this.timeRemainingFormatted = this.formatTime(0);
        // Auto-close modal and trigger timeout action
        this.dialogRef.close('timeout');
      } else {
        this.timeRemainingFormatted = this.formatTime(this.timeRemainingMs);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  private formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  onSignOut(): void {
    this.dialogRef.close('signout');
  }

  onExtendSession(): void {
    this.dialogRef.close('extend');
  }
}
